import { render } from "./GridHead.vue?vue&type=template&id=4b5df78e&ts=true"
import script from "./GridHead.vue?vue&type=script&lang=ts"
export * from "./GridHead.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__